import { type FC, type PropsWithChildren } from 'react';

import * as styles from './Scroller.css';

export const Scroller: FC<PropsWithChildren> = ({ children }) => <ul className={styles['container']}>{children}</ul>;
